import React from 'react';

import AdminPageHeader from '../common/AdminPageHeader';
import { DEPT_ACCESS_BLOCKED_COPY } from '../../constants/admission';

/** Empty state for a viewer whose every department is deactivated (Manage Admission + IPD). */
export default function DeptAccessBlockedPanel() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900">
      <AdminPageHeader />
      <div className="mx-auto max-w-3xl p-6">
        <div role="status" data-testid="dept-access-blocked" className="rounded-xl border border-amber-300 bg-amber-50 p-5 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-900/30 dark:text-amber-100">
          {DEPT_ACCESS_BLOCKED_COPY}
        </div>
      </div>
    </div>
  );
}
